import { Drawer, Text } from '@mantine/core';
import { drawerTransitionProps } from '@dealstack/frontend/shared/mechanism/styleguide/GlobalStyling';
import { useTranslationMipCreate } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { CreateProgrammeForm } from './CreateProgrammeForm';
import type { QuickCreateProgrammeValues } from './CreateProgrammeDrawer.types';

interface Props {
	dealId: string;
	opened: boolean;
	isCreating: boolean;
	onClose: () => void;
	onCreate: (values: QuickCreateProgrammeValues) => void;
}

/**
 * Creates a programme outright instead of walking the wizard. Defaults are applied without asking —
 * the organisation's when it has them, the built-in seed otherwise.
 */
export const CreateProgrammeDrawer = ({ dealId, opened, isCreating, onClose, onCreate }: Props) => {
	const tMipCreate = useTranslationMipCreate();

	return (
		<Drawer
			opened={opened}
			onClose={onClose}
			position="right"
			transitionProps={drawerTransitionProps}
			title={<Text size="B4Bold">{tMipCreate('quick_create.title')}</Text>}
		>
			<CreateProgrammeForm
				dealId={dealId}
				isCreating={isCreating}
				onClose={onClose}
				onCreate={onCreate}
			/>
		</Drawer>
	);
};
